
import React, { useState, useEffect } from "react";
import { Form, Button, Table } from "antd";
import { FormItemTypeEnum } from "../../../../components2/YhFormBox/Types"
import { YhFormItemsBox } from "../../../../components2/YhFormBox"
import { useCustomerModel } from "../customerModel"
import useMdmModel from "../../../../model/mdmModel"
import { useNavModel } from "../../../../model/navModel";
import { DetailType } from "../../../../types/FmsEnums";
import { setTitle, loadDictParam, findOption } from "../../../../utils/utils"
import { ICustomerSearch, ICustomerParams, ICustomerDetail, ICustomerInsert, ICustomerUpdata } from "../customerTypes"
import { DictEnum } from "../../../../types/MdmDIctEnum";

const CustomerDetail = () => {
    const [form] = Form.useForm();
    const { mdmCatalog, mdmBranch, mdmOrgan, dict, userAll, shop } = useMdmModel();
    const { selectedNavId, addNav, closeNav, getSelectedNavState, findNav, replaceNav } = useNavModel()
    const { addParam, selectedRow, bankList, customerTypeList, setAddParam, setSelectedRow, setBankList, setCustomerTypeList, updataAddParam, updataEditParam, insertDetail, updataDetail } = useCustomerModel()
    const [modes, setModes] = useState<any>(getSelectedNavState("state"))
    const { id, pageParams: { mode, id: ids } } = modes

    useEffect(() => {
        if (mode == DetailType.add) {
            form.setFieldsValue(addParam)
        } else if (mode == DetailType.edit || mode == DetailType.look) {
            let editRow = selectedRow[0] ?? {};
            //转换成 门店 或者用户的数据
            let res = {
                ...editRow,
                shopCustomers: editRow.shopCustomers?.map((item: any) => typeof item === "string" ? item : item.code) ?? [],
                userCustomers: editRow.userCustomers?.map((item: any) => typeof item === "string" ? item : item.code) ?? []
            }
            selectedRow[0] && form.setFieldsValue(res);
        }
    }, [])

    const onFinish = (values: ICustomerInsert | ICustomerUpdata) => {
        let newValue = {
            ...values,
            shopCustomers: values.shopCustomers ? values.shopCustomers?.map((item: any) => ({
                "code": findOption(item as string, shop)?.value,
                "name": findOption(item as string, shop)?.label
            })) : [],
            userCustomers: values.userCustomers ? values.userCustomers?.map((item: any) => ({
                "code": findOption(item as string, userAll)?.value,
                "name": findOption(item as string, userAll)?.label
            })) : [],
        }
        if (mode == DetailType.add) {
            insertDetail(newValue).then(res => res && close())
        } else if (mode == DetailType.edit) {
            updataDetail(newValue as ICustomerDetail).then(res => res && close())
        }
    }
    useEffect(() => {
        setBankList(loadDictParam(DictEnum.ACC_BACK, dict))
        setCustomerTypeList(loadDictParam(DictEnum.CUSTOMER_TYPE, dict))
    }, [])

    const close = () => {
        replaceNav(selectedNavId, "2-3")
    }
    const items = [
        {
            type: FormItemTypeEnum.Select,
            span: 6,
            fieldLabel: "分支编码",
            labelCol: { span: 6 },
            fieldName: "branch",
            options: mdmBranch
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "版本号",
            labelCol: { span: 6 },
            fieldName: "ver",
            disable: true,
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "客户编码",
            labelCol: { span: 6 },
            fieldName: "code",
            disable: mode == DetailType.edit

        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "客户名称",
            labelCol: { span: 6 },
            fieldName: "name",
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Select,
            span: 6,
            fieldLabel: "客户类型",
            labelCol: { span: 6 },
            fieldName: "categoryCode",
            rules: [{ required: true, message: '该项为必填项' }],
            // options: [{ key: "个人", value: "个人", label: "个人" }, { key: "集体", value: "集体", label: "集体" }]
            options: customerTypeList
        },
        {

            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "联系人",
            labelCol: { span: 6 },
            fieldName: "contact",
            rules: [{ required: true, message: '该项为必填项' }]

        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "联系电话",
            labelCol: { span: 6 },
            fieldName: "phone",
            rules: [{ required: true, message: '该项为必填项' }]

        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "联系地址",
            labelCol: { span: 6 },
            fieldName: "address",
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "传真号码",
            labelCol: { span: 6 },
            fieldName: "fax",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "电子邮箱",
            labelCol: { span: 6 },
            fieldName: "email",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "公司网址",
            labelCol: { span: 6 },
            fieldName: "website",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "办公电话",
            labelCol: { span: 6 },
            fieldName: "tel",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "客户级别",
            labelCol: { span: 6 },
            fieldName: "level",
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.TreeSelect,
            span: 6,
            fieldLabel: "所属机构",
            labelCol: { span: 6 },
            fieldName: "orgName",
            treeData: mdmOrgan
        },
        // {
        //     type: FormItemTypeEnum.Input,
        //     span: 6,
        //     fieldLabel: "机构编码",
        //     labelCol: { span: 6 },
        //     fieldName: "orgCode",
        // },        
        {
            type: FormItemTypeEnum.Input,
            span: 12,
            fieldLabel: "备注",
            labelCol: { span: 3 },
            fieldName: "note",
        },
        {
            type: FormItemTypeEnum.Select,
            span: 6,
            mode: "multiple",
            fieldLabel: "关联门店",
            labelCol: { span: 6 },
            fieldName: "shopCustomers",
            options: shop,
        },
        {
            type: FormItemTypeEnum.Select,
            span: 6,
            fieldLabel: "关联用户",
            labelCol: { span: 6 },
            mode: "multiple",
            fieldName: "userCustomers",
            options: userAll,
        },
    ]
    const items1 = [
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "发票抬头",
            labelCol: { span: 6 },
            fieldName: "invoiceTitle",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "营业执照",
            labelCol: { span: 6 },
            fieldName: "licenseNo",
        },
        {
            type: FormItemTypeEnum.Select,
            span: 6,
            fieldLabel: "开户银行",
            labelCol: { span: 6 },
            fieldName: "bank",
            options: bankList
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "银行账户",
            labelCol: { span: 6 },
            fieldName: "bankAcct",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "邮寄地址",
            labelCol: { span: 6 },
            fieldName: "postAddress",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "公司法人",
            labelCol: { span: 6 },
            fieldName: "corporation",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "经营范围",
            labelCol: { span: 6 },
            fieldName: "businessScope",
        },
        {
            type: FormItemTypeEnum.Switch,
            span: 6,
            fieldLabel: "状态",
            labelCol: { span: 6 },
            fieldName: "enable",
            valuePropName: "checked",
            checkedChildren: "启用",
            unCheckedChildren: "禁用"
        },

    ]
    const items2 = [
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "创建人",
            labelCol: { span: 6 },
            fieldName: "createUser",
            disable: true
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "创建时间",
            labelCol: { span: 6 },
            fieldName: "createTime",
            disable: true
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "修改人",
            labelCol: { span: 6 },
            fieldName: "updateUser",
            disable: true
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "修改时间",
            labelCol: { span: 6 },
            fieldName: "updateTime",
            disable: true
        },
    ]
    const title = <div className="font-bold font-size-lg">{setTitle(mode)}客户管理</div>
    const title1 = <div className="font-bold font-size-lg">开票信息</div>
    const title2 = <div className="font-bold font-size-lg">其他信息</div>
    const reset = () => {
        form.resetFields()
        if (mode == DetailType.add) {
            setAddParam({})
        } else if (mode == DetailType.edit) {
            form.setFieldsValue({ code: selectedRow[0].code })
            setSelectedRow([{ code: selectedRow[0].code }])
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => form.submit()}
        >保存</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => reset()}
        >重置</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => close()}
        >取消</Button>
    </>
    return <Form
        form={form}
        onValuesChange={mode == DetailType.add ? updataAddParam : updataEditParam}
        onFinish={onFinish}
    >
        <YhFormItemsBox disabled={mode == DetailType.look} items={items} title={title} action={action} IclassName="p-20" />
        <YhFormItemsBox disabled={mode == DetailType.look} items={items1} title={title1} IclassName="p-20" />
        <YhFormItemsBox disabled={mode == DetailType.look} items={items2} title={title2} IclassName="p-20" />
    </Form>
}
export default CustomerDetail